export default "__VITE_ASSET__ubNSBCGT__"